import { parseRawAddonListKey } from '@data/api/helpers';
import Addon from './Addon';
export default class AddonList {
    constructor(serverData) {
        Object.defineProperty(this, "items", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "sortItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.items.sort((a, b) => a.order < 0 ? 1 : b.order < 0 ? -1 : a.order - b.order)
        });
        if (!serverData || !serverData.success || !(serverData === null || serverData === void 0 ? void 0 : serverData.data)) {
            return;
        }
        const { data, items } = serverData;
        const keys = Object.keys(data);
        for (const key of keys) {
            const { adults, kids, roomId, packageId } = parseRawAddonListKey(key);
            const addonsId = Object.keys(data[key]);
            this.items.push(...addonsId.map((addonId) => new Addon(Object.assign(Object.assign({}, data[key][addonId]), { adults,
                kids,
                packageId,
                roomId }))));
        }
        if (items) {
            this.items.push(...items.map((item) => new Addon(item)));
        }
        this.sortItems();
    }
}
